'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Topbar() {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="h-14 flex items-center justify-between px-5 lg:px-6 border-b border-border bg-card flex-shrink-0 z-40">
      {/* Left: Mobile logo + search */}
      <div className="flex items-center gap-3">
        <div className="lg:hidden font-bold text-sm text-foreground">
          <span className="text-gradient-primary">REVERSAL</span>
        </div>
        <div className="hidden md:flex items-center gap-2 bg-muted rounded-md px-3 py-1.5 w-72 border border-border focus-within:border-primary/50 focus-within:bg-background transition-all duration-150">
          <Icon name="MagnifyingGlassIcon" size={14} className="text-muted-foreground flex-shrink-0" />
          <input
            type="text"
            placeholder="Search creators, brands, campaigns..."
            className="bg-transparent text-[13px] text-foreground placeholder-muted-foreground outline-none flex-1"
          />
          <kbd className="hidden xl:flex items-center gap-0.5 text-[10px] text-muted-foreground bg-border/50 px-1.5 py-0.5 rounded font-mono">
            ⌘K
          </kbd>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-2">
        <button
          className="md:hidden p-1.5 rounded-md hover:bg-muted text-muted-foreground hover:text-foreground transition-all"
          onClick={() => setSearchOpen(!searchOpen)}
        >
          <Icon name="MagnifyingGlassIcon" size={16} />
        </button>

        {/* Platform stats pill */}
        <div className="hidden lg:flex items-center gap-1.5 bg-positive/8 border border-positive/20 rounded-md px-2.5 py-1">
          <span className="w-1.5 h-1.5 rounded-full bg-positive animate-pulse" />
          <span className="text-[11px] font-600 text-positive">247 créateurs actifs</span>
        </div>

        <Link
          href="/campaign-builder"
          className="hidden sm:flex items-center gap-1.5 bg-primary hover:bg-primary/90 text-primary-foreground text-[13px] font-600 px-3 py-1.5 rounded-md transition-all duration-150 active:scale-95"
        >
          <Icon name="PlusIcon" size={14} />
          New Campaign
        </Link>

        <button className="relative p-1.5 rounded-md hover:bg-muted text-muted-foreground hover:text-foreground transition-all">
          <Icon name="BellIcon" size={16} />
          <span className="absolute top-1 right-1 w-1.5 h-1.5 bg-info rounded-full" />
        </button>

        <button className="p-1.5 rounded-md hover:bg-muted text-muted-foreground hover:text-foreground transition-all">
          <Icon name="Cog6ToothIcon" size={16} />
        </button>

        <div className="w-7 h-7 rounded-full bg-primary/15 flex items-center justify-center cursor-pointer hover:bg-primary/25 transition-all border border-primary/30">
          <span className="text-[10px] font-700 text-primary">SK</span>
        </div>
      </div>
    </header>
  );
}